import http from "@/plugins/axios_v2";

export default http.axiosInstance
